import {
  PensionSchemeRequest,
  NewReportingPeriodRequest,
  PostServiceCostRequest
} from './types';

export const createPensionSchemeRequestPayload = (
  pensionSchemeRequest: PensionSchemeRequest
) => {
  return {
    ...pensionSchemeRequest
  };
};

export const createReportingPeriodPayload = (
  newReportingPeriod: NewReportingPeriodRequest
) => {
  const body = new FormData();
  body.append('carryFunds', newReportingPeriod.carryFunds);
  body.append('start', newReportingPeriod.start);
  body.append('end', newReportingPeriod.end);
  body.append('investmentId', newReportingPeriod.investmentId);
  return body;
};

export const createServiceCostPayload = (
  postServiceCostRequest: PostServiceCostRequest
) => {
  const body = new FormData();
  if (postServiceCostRequest.note?.length) {
    const note = {
      value: postServiceCostRequest.note
    };
    body.append('note', JSON.stringify(note));
  }
  body.append('serviceCost', postServiceCostRequest.serviceCost);
  body.append(
    'serviceCostCurrency',
    postServiceCostRequest.serviceCostCurrency
  );
  body.append('costType', postServiceCostRequest.costType);
  body.append('investmentId', postServiceCostRequest.investmentId);
  body.append('source', postServiceCostRequest.source);
  body.append('timePeriodId', postServiceCostRequest.timePeriodId);

  return body;
};
